import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {OutlayService} from '../../services/outlay.service';
import {DatesParserService} from '../../../../../core/service/dates_parser.service';
import {MessagingService} from '../../../../../core/service/messaging.service';

import * as moment from 'moment';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import * as _ from 'underscore';
import {VnaPortalSelected} from '../../../../../core/data/messaging/VnaPortalSelected';

import Swal from 'sweetalert2'
import {Outlay} from '../../model/outlay';
import {AuthService} from '../../../../../core/service/auth.service';
import {LocalDataSource} from 'ng2-smart-table';
import {OutlayColumnsConfigService} from '../../services/outlay-columns-config.service';

@Component({
  selector: 'app-outlay-reporting',
  templateUrl: './outlay-reporting.component.html',
  styleUrls: ['./outlay-reporting.component.scss']
})
export class OutlayReportingComponent implements OnInit {

    rowsData: LocalDataSource;

    outlayData: Object;
    pkService: number;
    enabled: boolean;
    submitted: boolean;

    formSearch: FormGroup;
    settings: Object;

    errors: Object;

    fromHr:any;
    toHr:any;

    constructor(private outlayManager: OutlayService, private datesParser: DatesParserService, private auth: AuthService, private columnsConfig: OutlayColumnsConfigService, private messaging: MessagingService) {

        let from= new Date();
        from.setHours(0,0,0,0);
        this.fromHr=from;
        let to= new Date();
        to.setHours(23,59,59,0)
        this.toHr=to;

        this.outlayData = [];
        this.rowsData = new LocalDataSource();
        this.errors = {};
        this.formSearch = new FormGroup(
            {
                'start_date' : new FormControl('', Validators.required),
                'end_date' : new FormControl('', Validators.required),
                'alias_verification' : new FormControl('', Validators.required),
                'extra_campaign': new FormControl(),
                'extra_action': new FormControl(),
                'recalculate': new FormControl('1')
            }
        );

        this.settings = {
            columns: {},
            attr: {
                class: 'table table-bordered-sm table-responsive'
            },
            actions: {
                add: false,
                delete: false,
                edit: false
            }
        };
    }

    ngOnInit() {
        this.messaging.message.subscribe(
            (msg: any) => {
                if(msg instanceof VnaPortalSelected && !msg.isTheFirst()){
                    this.rowsData.reset();
                    this.rowsData.empty();
                }
            }
        )
    }

    findOutlay() {

        this.rowsData.empty();
        this.errors = {};
        if(!this.formSearch.valid){
            this.submitted = true;
            return;
        }

        this.pkService = this.formSearch.value.alias_verification;
        this.enabled = true;
        let query = this.datesParser.cleanDates(this.formSearch.value, ['start_date', 'end_date'], false);

        delete query['alias_verification'];
        this.outlayManager.findOutlay(this.auth.getPkPortal(), this.pkService, query).subscribe(
            result => {
                if(result.hasOwnProperty('errors')){
                    this.errors = result['errors']
                }
                else{
                    this.settings['columns'] = Object.assign({}, this.columnsConfig.getColumnsConfig(result['alias_verification']));
                    this.outlayData = result;
                    let mappedRows = this.outlayData['rows'].map(obj => { return new Outlay(obj); });
                    this.outlayData['rows'] = mappedRows;
                    this.rowsData.load(mappedRows);
                }

                this.enabled = false;
            }
        )
    }

    outlayToCsv(): void {
        this.rowsData.getFilteredAndSorted().then(
            (result) => {
                let headers = _.keys(this.settings['columns']);
                new Angular2Csv(result, 'outlay_report_' + moment().unix(), {
                    'showLabels' : true,
                    'headers' : headers
                });
            }
        );
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/analytics/outlay/components/outlay-reporting/outlay-reporting.component.ts